import {
  Body3RegularTypography,
  Box,
  Button,
  FlexColumn,
  Heading2SemiboldTypography,
  StyledImage,
  getColor,
} from "@wish-ui";
import FooterContainer from "components/FooterContainer";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IMAGE_PREFIX, PAGE_URLS } from "utils/constants";
import { transformMedia } from "utils/mediaTransform";

type ErrorFallbackProps = {
  resetError?: () => void;
};

const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialPathRef = useRef(location.pathname);

  // Reset error when navigation occurs
  useEffect(() => {
    if (location.pathname !== initialPathRef.current && resetError) {
      resetError();
    }
  }, [location.pathname, resetError]);
  return (
    <Box
      maxWidth="28rem"
      height="100vh"
      mx="auto"
      gap={16}
      flex={1}
      backgroundColor={getColor("background.default.default")}
    >
      <FlexColumn
        boxShadow="0px 1px 4px rgba(0, 0, 0, 0.12)"
        width="100%"
        px={20}
        py={20}
      >
        <img
          src={transformMedia(`${IMAGE_PREFIX}${"hamburger.svg"}`)}
          onClick={() => {
            navigate(PAGE_URLS.HAMBURGER_MENU);
          }}
          alt=""
          data-cy="drawer-hamburger"
        />
      </FlexColumn>
      <FlexColumn px={20} height="80vh">
        <FlexColumn
          width={"100%"}
          justifyContent="center"
          alignItems="center"
          height={"50%"}
          flex={1}
          gap={24}
        >
          <StyledImage
            src={transformMedia(`${IMAGE_PREFIX}error-graphic-sorry.png`)}
            alt="error-graphic-sorry"
          />
          <FlexColumn
            gap={8}
            justifyContent="center"
            alignItems="center"
            px={"48px"}
          >
            <Heading2SemiboldTypography fontFamily="Lexend" textAlign="center">
              Something went wrong
            </Heading2SemiboldTypography>
            <Body3RegularTypography
              color={getColor("text.default.secondary")}
              textAlign="center"
            >
              We're sorry, but something went wrong. Please try again later.
            </Body3RegularTypography>
          </FlexColumn>
        </FlexColumn>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </FlexColumn>
      <FooterContainer bgColor="#ffffff" />
    </Box>
  );
};
export default ErrorFallback;
